import { lighten } from "polished";

const solfaColors: { [prop: string]: string } = {};

export const darkColors = {

    cardBackground: "#282d35",
    grey3: "#EEE",
    grey5: "#DDD",
    grey7: "#aaa",
    grey9: "#999",
    greyA: "#777",
    greyD: "#555",
    greyE: "#333",
    score: "#777",

    dark: "#005552",
    boost: "#00968b",
    active: "#00AAA4",
    pale: "#a3d3ce",
    light: "#edf6f5",

    wrong: "#dd161d",
    memoryActive: "#573da8",
    mainBoost: "#00968b",
    easterBrown: "#443107",

    disabled: "#CCCCCC",
    info: "#f7c30c",
    snow: "#161B23",
    white: "black",
    black: "white",
};

const lightColors = {
    grey9: "#999",
    grey7: "#777",
    grey3: "#333",
    grey5: "#555",
    greyE: "#EEE",
    greyD: "#DDD",
    greyA: "#aaa",
    score: "#777",
    cardBackground: "white",

    active: "#00AAA4",
    boost: "#00968b",
    dark: "#005552",
    light: "#edf6f5",
    wrong: "#dd161d",
    pale: "#a3d3ce",
    memoryActive: "#573da8",
    choirActive: "#CD822E",
    mainBoost: "#00968b",
    easterBrown: "#443107",

    disabled: "#CCCCCC",
    info: "#f7c30c",
    snow: "#F6F4F4",
    white: "#FFFFFF",
    black: "black",
};

export default {
    ...lightColors,
    facebook: "#4267b2",
    google: "#DB4437",
    whiteOnActive: "white",
    snowOnActive: "#F6F4F4",
    christmasBlue: "#69c7c7",
    christmasLightBlue: "#98FDFC",

    correct: "#4bac09",
    incorrect: "#dd161d",

    play: "#7d44a5",
    playLight: lighten(0.35, "#7d44a5"),
    check: "#63c6bd",
    record: "#ff3664",

    blackShadow1: "rgba(0, 0, 0, 0.1)",
    blackShadow2: "rgba(0, 0, 0, 0.2)",
    blackShadow3: "rgba(0, 0, 0, 0.3)",
    blackShadow35: "rgba(0, 0, 0, 0.35)",
    blackShadow4: "rgba(0, 0, 0, 0.4)",
    blackShadow5: "rgba(0, 0, 0, 0.5)",
    blackShadow7: "rgba(0, 0, 0, 0.7)",
    youtube: "#af1117",

    solfa: solfaColors,
};

